import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserLeague } from '../user-league.model';

@JsonObject('UserLeaguesResultsResponse')
export class UserLeaguesResultsResponse extends ApiResultsResponse<UserLeague> {

  @JsonProperty('current_tier', Number)
  currentTier: number = 0;

  @JsonProperty('results', [UserLeague])
  override results: UserLeague[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
